'use strict';
/* global document $*/

$(document).ready(function() {
  // Add the $ composer button
  var Katex = {};

  $(window).on('action:composer.enhanced', function() {
    Katex.prepareFormattingTools();
  });

  /**
  * Add a dollar button to the composer
  */
  Katex.prepareFormattingTools = function() {
    require(['composer/formatting', 'composer/controls'], function(formatting, controls) {
        formatting.addButtonDispatch('usd', function(textarea, selectionStart, selectionEnd) {
          if (selectionStart === selectionEnd) {
            controls.insertIntoTextarea(textarea, '$');
            controls.updateTextareaSelection(textarea, selectionStart + 1, selectionStart + 1);
          } else {
            controls.wrapSelectionInTextareaWith(textarea, '$');
            controls.updateTextareaSelection(textarea, selectionStart + 1, selectionEnd + 1);
          }
        });
    });
  };
});